import { createMuiTheme } from "@material-ui/core";

const baseTheme = createMuiTheme();
const spacing = baseTheme.spacing

export default spacing;
